import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertDollarToNumber'
})
export class ConvertDollarToNumberPipe implements PipeTransform {

  transform(val: any): any {
		if( typeof val === 'string' ){
			return parseFloat(val.replace(/[\$,]/g, ""));
		}
		else {
			return parseFloat(val);
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/convert-dollar-to-number.pipe.ts